import S, { DataSignal } from 's-js';
import { UserSummary } from 'data/models/UserSummary';
import { BootstrapCache } from 'core/app/bootstrapCache';
import { AuthorizedDataData } from 'data/models/AuthorizedData';
import { LoginRequest } from 'data/models/ChangePasswordRequest';
import { TwoFAEmailRequest, TwoFACodeRequest } from 'data/models/Accounts';
import { IAjax } from 'lib/Ajax';
import { Entrypoints } from 'core/app/entrypoints';

export type Login = ReturnType<typeof Login>;

export interface LoginParams {
    useLandingPage : boolean;
    onHidePopup : () => void;
}

export function Login(ajax : IAjax, entrypoints : Entrypoints, cache : BootstrapCache, user : DataSignal<UserSummary | null>, { useLandingPage, onHidePopup } : LoginParams) {
    let login = ajax.Url<LoginRequest>(entrypoints.Login),
        dataClient = ajax.Url<AuthorizedDataData>(entrypoints.AuthorizedData),
        loginRequest = new LoginRequest(),
        loginError = S.data(false),
        twoFAEmail = ajax.Url<TwoFAEmailRequest>(entrypoints.TwoFAEmail),
        twoFACode = ajax.Url<TwoFACodeRequest>(entrypoints.TwoFACode),
        twoFAEmailRequest = new TwoFAEmailRequest(),
        twoFACodeRequest = new TwoFACodeRequest(),
        hasTwoFA = S.data(false),
        twoFAEmailError = S.data(false),
        twoFACodeError = S.data(false),
        twoFAUserValue = S.data(''),
        twoFAEncryptedValue = S.data('0');

    return {
        LoginRequest: loginRequest,
        LoginError: loginError,
        Login: Login,
        ForgotPassword: ForgotPassword,
        HidePopup: onHidePopup,
        TwoFAEmailRequest: twoFAEmailRequest,
        TwoFACodeRequest: twoFACodeRequest,
        TwoFAEmailError: twoFAEmailError,
        TwoFACodeError: twoFACodeError,
        TwoFAEmail: twoFAEmail,
        TwoFACode: twoFACode,
        twoFAEncryptedValue,
        twoFAUserValue,
        hasTwoFA,
        Check2FACode: Check2FACode,
        Check2FAEmail: Check2FAEmail,
    };

    function Check2FACode() {
        twoFACodeError(false);
        twoFACodeRequest.Number(twoFAUserValue());
        twoFACodeRequest.Encrypted(twoFAEncryptedValue());

        let req = twoFACode.Post(twoFACodeRequest);
        req.then(_ => {
            twoFACodeError(false);
            hasTwoFA(true);
        }).catch(function () {
            twoFACodeError(true);
        });
    }

    function Check2FAEmail() {
        twoFAEmailError(false);
        let req = twoFAEmail.Post(twoFAEmailRequest);
        req.then(json => {
            twoFAEncryptedValue(json as any);
            loginRequest.UserName(twoFAEmailRequest.Email());
        }).catch(function () {
            twoFAEmailError(true);
        });
    }

    function Login() {
        loginError(false);

        let req = login.Post(loginRequest);
        req.then(() =>
            dataClient.Get()
        ).then(json => {
            const
                model = cache.AuthorizedData.update1(req.Date, json),
                userSummary = model.UserSummary()!;

            S.freeze(() => {
                user(userSummary);
                onHidePopup();
            });

            if (useLandingPage) {
                window.location.hash = userSummary.LandingPage() || '';
            } else {
                // The useLandingPage: false option is mainly used by the ajax errors component.
                // Reloading is for the benefit of users who've just gotten the login popup due to an auth error
                // and need to reload the window to retry their failed request.
                // This is a terrible sledge hammer - a much better solution would be to weave retry logic into
                // our ajax layer, such that we only need to retry the failed request and not reload the whole window.
                window.location.reload();
            }
        }).catch(function () {
            loginError(true);
        });
    }

    function ForgotPassword() {
        // close modal
        onHidePopup();
        window.location.hash = 'forgotpassword';
    }
}



// WEBPACK FOOTER //
// ./apps/portcall/login/model.ts